module.exports = __webpack_public_path__ + "static/media/Boy-Bedroom-2.fb9cd381.webp";